import React, { useCallback, useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import { BlendedSnapshot, BlendedSnapshotUpcoming } from "lib-core";
import { ButtonBox, HistoryButton } from "./snapshotBoxes.styles";
import { BlendedSnapshotTable } from "./BlendedSnapshotTable";

interface Props {
  blendedSnapshots: BlendedSnapshot[] | undefined;
  latestUsableSnapshot: BlendedSnapshot | undefined;
  blendedSnapshotUpcoming: BlendedSnapshotUpcoming | undefined;
  downloadBlendedSnapshotMetadata: (
    id: string,
    version: number
  ) => Promise<void>;
}

// Owns the "Show history" button and the Dialog, including the open/close
// state. Keeping isDialogOpen local to this component means toggling the
// dialog only re-renders this subtree, not the parent BlendedSnapshotBox.
export const BlendedSnapshotHistoryDialog = ({
  blendedSnapshots,
  latestUsableSnapshot,
  blendedSnapshotUpcoming,
  downloadBlendedSnapshotMetadata,
}: Props): JSX.Element | null => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const toggleBlendedSnapshotHistoryDialog = useCallback(() => {
    setIsDialogOpen((prev) => !prev);
  }, []);

  if (!blendedSnapshots) {
    return null;
  }

  return (
    <>
      {!!blendedSnapshots.length && (
        <ButtonBox>
          <HistoryButton
            variant="outlined"
            onClick={toggleBlendedSnapshotHistoryDialog}
          >
            <Typography variant="h5">Show history</Typography>
          </HistoryButton>
        </ButtonBox>
      )}
      <Dialog open={isDialogOpen} maxWidth="xl">
        <DialogTitle>Blended snapshot history</DialogTitle>
        <DialogContent>
          <BlendedSnapshotTable
            latestUsableSnapshot={latestUsableSnapshot}
            blendedSnapshots={blendedSnapshots}
            blendedSnapshotUpcoming={blendedSnapshotUpcoming}
            downloadBlendedSnapshotMetadata={downloadBlendedSnapshotMetadata}
          />
        </DialogContent>
        <br />
        <DialogActions>
          <Button
            onClick={toggleBlendedSnapshotHistoryDialog}
            variant="outlined"
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default BlendedSnapshotHistoryDialog;
